import { render, staticRenderFns } from "./workout-by-muscle.vue?vue&type=template&id=e8d30122&"
import script from "./workout-by-muscle.vue?vue&type=script&lang=js&"
export * from "./workout-by-muscle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports